import axios from 'axios';
import suid from './suid';
import * as lodash from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { merge } from 'lodash';
// export class DeferPromise {
//     private defer:RespDefer
//     constructor(defer:RespDefer) {
//         this.defer = defer
//     }
//     done(cb: Function) {
//         this.defer.successCallback = cb;
//         return this;
//     }
//
//     fail(cb: Function) {
//         this.defer.failCallback = cb;
//         return this;
//     }
//
//     always(cb: Function) {
//         this.defer.alwaysCallback = cb;
//         return this;
//     }
//
//     abort() {
//         if (this.defer.canceler) {
//             this.defer.canceler.cancel('abort')
//         }
//     }
// }
// export class RespDefer {
//     successCallback?: Function;
//     failCallback?: Function;
//     alwaysCallback?: Function;
//
//     canceler?: CancelTokenSource;
//
//     resolve(d?:any) {
//         this.successCallback && this.successCallback(d);
//     }
//     reject(e?:any) {
//         this.failCallback && this.failCallback(e);
//     }
//     terminate() {
//         this.alwaysCallback && this.alwaysCallback();
//     }
//
//     promise() {
//         return new DeferPromise(this);
//     }
//
//
// }
var globalRequestStore = {};
var maskClassName = '.ksc-loading-mask';
var mask = {
    insert: function () {
        var masks = document.querySelectorAll(maskClassName);
        if (masks.length) {
            return;
        }
        var mask = document.createElement('div');
        mask.className = maskClassName;
        document.body.append(mask);
    },
    remove: function () {
        if (lodash.isEmpty(globalRequestStore)) {
            document.querySelectorAll(maskClassName).forEach(function (el) {
                el.remove();
            });
        }
    }
};
var ApiRequestFactory = /** @class */ (function () {
    function ApiRequestFactory(cfg) {
        this.cfg = cfg;
        this.axiosInstance = axios.create(cfg);
    }
    ApiRequestFactory.prototype.request = function (baseAxiosConfig, axiosConfig, options) {
        var _this = this;
        var config = merge({}, baseAxiosConfig, axiosConfig, {
            headers: {
                'X-KSC-REQUEST-ID': uuidv4(),
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        var uuid = suid(config.params.Action);
        var cancelSource = axios.CancelToken.source();
        config.cancelToken = cancelSource.token;
        // let defer = new RespDefer()
        // defer.canceler = cancelSource;
        var isNoLoading = options && options.noLoading;
        if (!isNoLoading) {
            mask.insert();
        }
        globalRequestStore[uuid] = new Promise(function (resolve, reject) {
            _this.axiosInstance(config).then(function (resp) {
                // defer.resolve(resp);
                if (resp.status !== 200) {
                    reject(resp.statusText);
                }
                else {
                    resolve(resp.data);
                }
            }).catch(function (e) {
                reject(e);
                // if (axios.isCancel(e)) {
                //     // cancel的错不处理
                // } else {
                //
                // }
                // defer.reject(e);
            }).then(function () {
                delete globalRequestStore[uuid];
                // always
                mask.remove();
                // defer.terminate();
            });
        });
        return globalRequestStore[uuid]; //defer.promise();
    };
    ApiRequestFactory.prototype.wrap = function (cfg) {
        var _this = this;
        // const baseAxiosConfig: AxiosRequestConfig = {
        //     method: cfg.method || 'GET',
        //     params: {
        //         Action: cfg.Action,
        //         Service: cfg.Service,
        //         Version: cfg.Version
        //     }
        // }
        return function (axiosConfig, options) {
            return _this.request(cfg, axiosConfig, options);
        };
    };
    return ApiRequestFactory;
}());
export { ApiRequestFactory };
//# sourceMappingURL=axiosWrapper.js.map